import { render, staticRenderFns } from "./GoBackButton.vue?vue&type=template&id=08ec2742&scoped=true&lang=pug&"
import script from "./GoBackButton.vue?vue&type=script&lang=js&"
export * from "./GoBackButton.vue?vue&type=script&lang=js&"
import style0 from "./GoBackButton.vue?vue&type=style&index=0&id=08ec2742&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec2742",
  null
  
)

export default component.exports